import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cc62d41"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_3 = {
  key: 0,
  class: "is-danger-message"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_6 = {
  key: 1,
  class: "is-danger-message"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "button" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_17 = {
  key: 2,
  class: "is-danger-message"
}


import { UseNumberHelper } from "../../../../Helper/Functional/UseNumberHelper";
import {
  UseFixedCosts,
  emitFunction,
} from "../../../../Pages/Admin/FixedCosts/Hooks/UseFixedCosts";
import { computed, toRef, watch } from "vue";

const __default__ = {
  name: "BatchFixedFileConfiguration",
};
import { useField } from "vee-validate";

import { UseValidateHelper } from "../../../../Helper/Functional/UseValidateHelper";
import { IFixedBatchSingle } from "../../../../Pages/Admin/FixedCosts/Typings/FixedCostsTypes";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    startDate: null,
    endDate: null,
    taxonomyOne: null,
    taxonomyTwo: null,
    taxonomyThree: null,
    taxonomyFour: null,
    cost: null,
    availableColumns: null
  },
  emits: ["update:cost", "update:startDate", "update:endDate", "update:taxonomyOne", "update:taxonomyTwo", "update:taxonomyThree", "update:taxonomyFour", "showLastStepEmitter"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:cost", val: IFixedBatchSingle): void;
  (e: "update:startDate", val: IFixedBatchSingle): void;
  (e: "update:endDate", val: IFixedBatchSingle): void;
  (e: "update:taxonomyOne", val: IFixedBatchSingle): void;
  (e: "update:taxonomyTwo", val: IFixedBatchSingle): void;
  (e: "update:taxonomyThree", val: IFixedBatchSingle): void;
  (e: "update:taxonomyFour", val: IFixedBatchSingle): void;
  (e: "showLastStepEmitter", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  startDate: IFixedBatchSingle;
  endDate: IFixedBatchSingle;
  taxonomyOne: IFixedBatchSingle;
  taxonomyTwo: IFixedBatchSingle;
  taxonomyThree: IFixedBatchSingle;
  taxonomyFour: IFixedBatchSingle;
  cost: IFixedBatchSingle;
  availableColumns: string[];
}

const { displayCurrencySymbol } = UseNumberHelper();
const { computedWatcherHookForEmits } = UseFixedCosts();




const startDateCompute = computedWatcherHookForEmits(
  toRef(props, "startDate"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:startDate"
);

const endDateCompute = computedWatcherHookForEmits(
  toRef(props, "endDate"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:endDate"
);
const taxonomyOneCompute = computedWatcherHookForEmits(
  toRef(props, "taxonomyOne"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:taxonomyOne"
);
const taxonomyTwoCompute = computedWatcherHookForEmits(
  toRef(props, "taxonomyTwo"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:taxonomyTwo"
);
const taxonomyThreeCompute = computedWatcherHookForEmits(
  toRef(props, "taxonomyThree"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:taxonomyThree"
);
const taxonomyFourCompute = computedWatcherHookForEmits(
  toRef(props, "taxonomyFour"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:taxonomyFour"
);
const costCompute = computedWatcherHookForEmits(
  toRef(props, "cost"),
  emit as emitFunction<IFixedBatchSingle>,
  "update:cost"
);

const mandatoryData = computed(
  () =>
    !!costCompute.value.value &&
    !!startDateCompute.value.value &&
    !!taxonomyOneCompute.value.value
);

//Form stuff
const { isRequired, isDate } = UseValidateHelper();

const { errorMessage: errorMessageTaxOne, value: taxonomyOneValidation } = useField<
  string | null
>("taxonomy_1", isRequired("The taxonomy one field is required."));
const { errorMessage: errorMessageCost, value: costValidation } = useField<string | null>(
  "cost",
  isRequired("The cost field is required")
);
const { errorMessage: errorMessageCostDate, value: costDateValidation } = useField<
  Date | null | string
>("costDate", isDate("The cost date field is required"));

watch(
  [
    () => ({ ...taxonomyOneCompute.value }),
    () => ({ ...costCompute.value }),
    () => ({ ...startDateCompute.value }),
  ],
  ([newTax, newCost, newCostDate], [oldTax, oldCost, oldCostDate]) => {
    if (newTax.value !== oldTax.value) {
      taxonomyOneValidation.value = newTax.value as string | null;
    }
    if (newCost !== oldCost) {
      costValidation.value = newCost.value as string | null;
    }
    if (newCostDate !== oldCostDate) {
      costDateValidation.value = newCostDate.value as Date | null;
    }
  },
  { deep: true }
);

watch(props.availableColumns, () => {
  startDateCompute.value.value = null;
  endDateCompute.value.value = null;
  taxonomyOneCompute.value.value = null;
  taxonomyTwoCompute.value.value = null;
  taxonomyThreeCompute.value.value = null;
  taxonomyFourCompute.value.value = null;
  costCompute.value.value = null;
});

watch(mandatoryData, (val: boolean) => {
  emit("showLastStepEmitter", val);
});

return (_ctx: any,_cache: any) => {
  const _component_o_switch = _resolveComponent("o-switch")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_datepicker = _resolveComponent("o-datepicker")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_input = _resolveComponent("o-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Cost Date *" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(startDateCompute).type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(startDateCompute).type) = $event)),
              variant: _unref(startDateCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(startDateCompute).value = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(startDateCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(startDateCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: _unref(startDateCompute).value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(startDateCompute).value) = $event)),
                  name: "startDate"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableColumns, (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_1))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(startDateCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_datepicker, {
                  modelValue: _unref(startDateCompute).value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(startDateCompute).value) = $event)),
                  name: "startDate",
                  placeholder: "Click to select...",
                  icon: "calendar-today",
                  "trap-focus": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(startDateCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(startDateCompute).value === null,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(startDateCompute).value = null)),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(errorMessageCostDate))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(errorMessageCostDate)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Taxonomy 1 *" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(taxonomyOneCompute).type,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(taxonomyOneCompute).type) = $event)),
              variant: _unref(taxonomyOneCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_unref(taxonomyOneCompute).value = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(taxonomyOneCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(taxonomyOneCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: _unref(taxonomyOneCompute).value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(taxonomyOneCompute).value) = $event)),
                  name: "taxonomy_1",
                  "data-vv-name": "taxonomy 1"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableColumns, (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_4))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyOneCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  modelValue: _unref(taxonomyOneCompute).value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(taxonomyOneCompute).value) = $event)),
                  name: "taxonomy_1",
                  "data-vv-name": "taxonomy 1"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyOneCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(taxonomyOneCompute).value === null,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(taxonomyOneCompute).value = null)),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(errorMessageTaxOne))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(errorMessageTaxOne)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Taxonomy 2" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(taxonomyTwoCompute).type,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(taxonomyTwoCompute).type) = $event)),
              variant: _unref(taxonomyTwoCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[11] || (_cache[11] = ($event: any) => (_unref(taxonomyTwoCompute).value = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(taxonomyTwoCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(taxonomyTwoCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: _unref(taxonomyTwoCompute).value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(taxonomyTwoCompute).value) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableColumns, (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_7))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyTwoCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  modelValue: _unref(taxonomyTwoCompute).value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(taxonomyTwoCompute).value) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyTwoCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(taxonomyTwoCompute).value === null,
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(taxonomyTwoCompute).value = null)),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Taxonomy 3" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(taxonomyThreeCompute).type,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(taxonomyThreeCompute).type) = $event)),
              variant: _unref(taxonomyThreeCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[16] || (_cache[16] = ($event: any) => (_unref(taxonomyThreeCompute).value = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(taxonomyThreeCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(taxonomyThreeCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: _unref(taxonomyThreeCompute).value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(taxonomyThreeCompute).value) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableColumns, (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_9))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyThreeCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  modelValue: _unref(taxonomyThreeCompute).value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(taxonomyThreeCompute).value) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyThreeCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(taxonomyThreeCompute).value === null,
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(taxonomyThreeCompute).value = null)),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Taxonomy 4" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(taxonomyFourCompute).type,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(taxonomyFourCompute).type) = $event)),
              variant: _unref(taxonomyFourCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[21] || (_cache[21] = ($event: any) => (_unref(taxonomyFourCompute).value = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(taxonomyFourCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(taxonomyFourCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: _unref(taxonomyFourCompute).value,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(taxonomyFourCompute).value) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableColumns, (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_11))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyFourCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  modelValue: _unref(taxonomyFourCompute).value,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(taxonomyFourCompute).value) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(taxonomyFourCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_12
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(taxonomyFourCompute).value === null,
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_unref(taxonomyFourCompute).value = null)),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Cost *" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(costCompute).type,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(costCompute).type) = $event)),
              variant: _unref(costCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[26] || (_cache[26] = ($event: any) => (_unref(costCompute).value = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(costCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(costCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: _unref(costCompute).value,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(costCompute).value) = $event)),
                  "data-vv-name": "cost",
                  name: "cost"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableColumns, (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_13))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(costCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_field, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_14, [
                      _createElementVNode("button", _hoisted_15, _toDisplayString(_unref(displayCurrencySymbol)), 1)
                    ]),
                    _createVNode(_component_o_input, {
                      modelValue: _unref(costCompute).value,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(costCompute).value) = $event)),
                      name: "cost",
                      step: "0.01",
                      type: "number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(costCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(costCompute).value === null,
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_unref(costCompute).value = null)),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(errorMessageCost))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("span", null, _toDisplayString(_unref(errorMessageCost)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})